import type { FC, SVGProps } from 'react';

export const KlaviyoLogo: FC<SVGProps<SVGSVGElement>> = ({
  width = 28,
  height = 28,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path fill="#FF6900" d="M22 4H2v18h20l-5-9 5-9Z" />
  </svg>
);
